/* Motion layer v4.3: selectable shader backgrounds (lazy, low-res, adaptive, never switches itself off), scroll reveals, hero parallax, magnetic buttons, progress bar, drag fix for the card ring. */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce)return;
  var root=document.documentElement;
  var fine=window.matchMedia&&matchMedia('(pointer:fine)').matches;
  var home=location.pathname==='/'||location.pathname==='';
  var HERO='.h3, .ah';
  var cs=document.currentScript,BASE=cs&&cs.src?cs.src.replace(/grim-motion\.js.*$/,''):'';
  function load(key,file,cb){
    var u=(window.__gurl&&window.__gurl[key])||(BASE?BASE+file:'');
    if(!u)return;
    var s=document.createElement('script');s.src=u;s.async=true;s.onload=cb;document.head.appendChild(s);
  }

  function bar(){var b=document.createElement('div');b.className='mo-bar';b.setAttribute('aria-hidden','true');document.body.appendChild(b);return b}

  /* ---------- background shaders ---------- */
  var PRESETS=[{id:'aurora',name:'Harvest Glow'},{id:'embers',name:'Bonfire'},{id:'hills',name:'Autumn Hills'},{id:'dust',name:'Gold Dust'},{id:'cosmos',name:'Nebula'},{id:'retro',name:'Sunset Grid'},{id:'silk',name:'Golden Silk'},{id:'calm',name:'Calm (off)'}];
  var preset='aurora',SH={};
  try{var sv=localStorage.getItem('gbg');if(sv&&PRESETS.some(function(p){return p.id===sv}))preset=sv}catch(e){}
  root.setAttribute('data-gbg',preset);
  var VS='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var cols={A:[1,.62,.18],B:[.86,.2,.32],K:[.07,.05,.04]};
  function readCols(){
    var cs2=getComputedStyle(root);
    function rgb(v,def){var m=(cs2.getPropertyValue(v)||'').trim().split(/[ ,]+/).map(Number);return m.length>=3&&m.every(function(x){return x===x})?[m[0]/255,m[1]/255,m[2]/255]:def}
    function hex(v,def){var s=(cs2.getPropertyValue(v)||'').trim();if(/^#[0-9a-f]{6}$/i.test(s))return[parseInt(s.slice(1,3),16)/255,parseInt(s.slice(3,5),16)/255,parseInt(s.slice(5,7),16)/255];return def}
    cols.A=rgb('--e-rgb',cols.A);cols.B=rgb('--e-pump-rgb',cols.B);cols.K=hex('--e-ink',cols.K);
    if(root.getAttribute('data-gt')!=='dark'){cols.A=[1,.62,.18];cols.B=[.86,.2,.32]}
  }
  var insts=[],raf=0,last=0,mouse={x:-9999,y:-9999},t0=performance.now(),scrolling=false,dragging=false,sct=0,mul=1,ema=17,lastTs=0,gov=0,bad=0,good=0,gap=42;
  addEventListener('pointermove',function(e){mouse.x=e.clientX;mouse.y=e.clientY},{passive:true});
  addEventListener('scroll',function(){scrolling=true;clearTimeout(sct);sct=setTimeout(function(){scrolling=false;ema=17;bad=0},160)},{passive:true});

  function sh(gl,type,src){var s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);return gl.getShaderParameter(s,gl.COMPILE_STATUS)?s:null}
  function hide(i){i.off=true;if(i.cv)i.cv.style.display='none';i.host.classList.remove('mo-gl-on')}
  function ensure(i){
    if(i.gl)return true;
    var cv=document.createElement('canvas');cv.className='mo-gl';cv.setAttribute('aria-hidden','true');
    var gl=cv.getContext('webgl',{alpha:false,antialias:false,depth:false,stencil:false,powerPreference:'low-power'});
    if(!gl){i.dead=true;return false}
    var vs=sh(gl,gl.VERTEX_SHADER,VS);if(!vs){i.dead=true;return false}
    i.vs=vs;
    var buf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buf);
    gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
    i.cv=cv;i.gl=gl;
    /* if the browser drops the graphics context (heavy load), pause, then rebuild when it comes back */
    cv.addEventListener('webglcontextlost',function(e){e.preventDefault();i.lost=true;i.u=null});
    cv.addEventListener('webglcontextrestored',function(){
      i.lost=false;
      if(i.cv&&i.cv.parentNode)i.cv.parentNode.removeChild(i.cv);
      i.gl=null;i.cv=null;i.vs=null;i.pg=null;i.u=null;i.built=false;
      build(i);kick();
    });
    i.host.insertBefore(cv,i.host.firstChild);i.host.classList.add('mo-host');
    return true;
  }
  function build(i){
    i.built=true;
    if(i.dead)return;
    if(preset==='calm'||!SH[preset]){hide(i);return}
    if(!ensure(i))return;
    var gl=i.gl,f=sh(gl,gl.FRAGMENT_SHADER,SH[preset]);
    if(!f){hide(i);return}
    var pg=gl.createProgram();gl.attachShader(pg,i.vs);gl.attachShader(pg,f);gl.linkProgram(pg);
    gl.deleteShader(f);
    if(!gl.getProgramParameter(pg,gl.LINK_STATUS)){hide(i);return}
    if(i.pg)gl.deleteProgram(i.pg);
    i.pg=pg;gl.useProgram(pg);
    var loc=gl.getAttribLocation(pg,'p');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    var u={};['R','T','M','A','B','K'].forEach(function(k){u[k]=gl.getUniformLocation(pg,k)});i.u=u;
    i.off=false;i.cv.style.display='';i.host.classList.add('mo-gl-on');
  }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(en){
      for(var k=0;k<insts.length;k++)if(insts[k].host===en.target){var i=insts[k];i.vis=en.isIntersecting;if(i.vis&&!i.built)build(i)}
    });
    kick();
  },{rootMargin:'80px'}):null;
  function reg(host,soft){
    if(host.getAttribute('data-mog'))return;host.setAttribute('data-mog','1');
    var i={host:host,soft:soft,vis:!io,mx:-9999,my:-9999};
    if(soft)host.classList.add('mo-soft');
    insts.push(i);
    if(io)io.observe(host);else build(i);
  }
  function size(i){
    var s=Math.min(window.devicePixelRatio||1,1)*(i.soft?.3:.4)*mul;
    var w=Math.max(2,Math.round(i.cv.clientWidth*s)),h=Math.max(2,Math.round(i.cv.clientHeight*s));
    var a=w*h,cap=240000;
    if(a>cap){var k=Math.sqrt(cap/a);w=Math.max(2,Math.round(w*k));h=Math.max(2,Math.round(h*k))}
    if(i.cv.width!==w||i.cv.height!==h){i.cv.width=w;i.cv.height=h;i.gl.viewport(0,0,w,h)}
  }
  function draw(i,t){
    var gl=i.gl;size(i);
    var r=i.cv.getBoundingClientRect(),sx=i.cv.width/Math.max(1,r.width),sy=i.cv.height/Math.max(1,r.height);
    var tx=(mouse.x-r.left)*sx,ty=i.cv.height-(mouse.y-r.top)*sy;
    if(i.mx<-9000){i.mx=tx;i.my=ty}else{i.mx+=(tx-i.mx)*.12;i.my+=(ty-i.my)*.12}
    gl.uniform2f(i.u.R,i.cv.width,i.cv.height);gl.uniform1f(i.u.T,t);gl.uniform2f(i.u.M,i.mx,i.my);
    gl.uniform3fv(i.u.A,cols.A);gl.uniform3fv(i.u.B,cols.B);gl.uniform3fv(i.u.K,cols.K);
    gl.drawArrays(gl.TRIANGLES,0,3);
  }
  function live(q){return q.vis&&!q.off&&!q.dead&&!q.lost&&q.gl&&q.u}
  function frame(ts){
    raf=0;
    var any=false;
    for(var k=0;k<insts.length;k++)if(live(insts[k]))any=true;
    if(!any||document.hidden){lastTs=0;return}
    raf=requestAnimationFrame(frame);
    if(lastTs)ema=ema*.92+(ts-lastTs)*.08;
    lastTs=ts;
    /* while dragging or scrolling the background keeps moving, just at a lower rate so the ring gets the budget */
    if(ts-last<(scrolling||dragging?Math.max(gap,70):gap))return;
    last=ts;
    var t=(ts-t0)/1000;
    insts.forEach(function(i){if(live(i))draw(i,t)});
    /* governor: only lowers quality (resolution, then frame rate). It never turns the background off. */
    if(++gov>=60){
      gov=0;
      if(scrolling||dragging){bad=0;return}
      if(ema>36){good=0;if(++bad>=2){bad=0;if(mul>.34)mul*=.85;else if(gap<100)gap+=18}}
      else{bad=0;if(ema<22&&++good>=4){good=0;if(gap>42)gap-=18;else if(mul<1)mul=Math.min(1,mul*1.12)}}
    }
  }
  function kick(){if(!raf)raf=requestAnimationFrame(frame)}
  document.addEventListener('visibilitychange',kick);
  function setPreset(id,auto){
    if(id!=='calm'&&!SH[id])return;
    preset=id;root.setAttribute('data-gbg',id);
    if(!auto){mul=1;ema=17;gov=0;bad=0;good=0;gap=42;try{localStorage.setItem('gbg',id)}catch(e){}}
    insts.forEach(function(i){if(i.built||i.vis)build(i)});
    kick();
    try{window.dispatchEvent(new CustomEvent('gbg',{detail:id,bubbles:false}))}catch(e){}
  }
  window.__gbg={list:PRESETS,get:function(){return preset},set:setPreset};

  function shaders(){
    readCols();
    ['.h3__bg','.e-coll','.es','.cart-items-component'].forEach(function(sel){var e=document.querySelector(sel);if(e)reg(e,false)});
    ['.gst','.e-games','.apple-steps','.bt','.gs__hero'].forEach(function(sel){var e=document.querySelector(sel);if(e)reg(e,true)});
    new MutationObserver(function(){readCols()}).observe(root,{attributes:true,attributeFilter:['data-gt']});
    kick();
  }

  /* ---------- the card ring: a drag must never open the product link ---------- */
  function fixDrag(){
    var st=document.querySelector('.h3__stage');if(!st)return;
    st.querySelectorAll('a,img').forEach(function(n){n.setAttribute('draggable','false')});
    st.addEventListener('dragstart',function(e){e.preventDefault()});
    var down=false,mv=false,sx=0,sy=0;
    st.addEventListener('pointerdown',function(e){down=true;dragging=true;mv=false;sx=e.clientX;sy=e.clientY},true);
    addEventListener('pointermove',function(e){if(down&&!mv&&(Math.abs(e.clientX-sx)>5||Math.abs(e.clientY-sy)>5))mv=true},{passive:true});
    function up(){down=false;dragging=false;ema=17;bad=0}
    addEventListener('pointerup',up);
    addEventListener('pointercancel',up);
    st.addEventListener('click',function(e){if(mv){e.preventDefault();e.stopPropagation();mv=false}},true);
  }

  function reveals(){
    if(!('IntersectionObserver' in window))return;
    var secs=[].slice.call(document.querySelectorAll('#MainContent .shopify-section, main .shopify-section'));
    var seen=[];
    secs=secs.filter(function(s){
      if(seen.indexOf(s)>-1)return false;seen.push(s);
      if(s.querySelector('.h3,.ah,.ep,[role="dialog"],.facets,.facets-block-wrapper'))return false;
      if(s.getBoundingClientRect().height<60)return false;
      return true;
    });
    if(!secs.length)return;
    root.classList.add('mo-on');
    var kidSel='.e-games a, product-card, .gst__item, .apple-steps__card, .apple-stats [data-apple-reveal], .e-why [data-apple-reveal]';
    var rio=new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(!en.isIntersecting)return;
        var s=en.target;s.classList.add('mo-in');rio.unobserve(s);
        setTimeout(function(){
          s.classList.add('mo-done');
          s.querySelectorAll('.mo-kid').forEach(function(k){k.classList.remove('mo-kid')});
        },2200);
      });
    },{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    secs.forEach(function(s){
      s.classList.add('mo-sec');
      var i=0;
      s.querySelectorAll(kidSel).forEach(function(k){k.classList.add('mo-kid');k.style.setProperty('--i',Math.min(i++,9))});
      rio.observe(s);
    });
    setTimeout(function(){secs.forEach(function(s){s.classList.add('mo-in')})},4500);
  }

  function magnetic(){
    if(!fine)return;
    document.querySelectorAll('.h3__btn, .h3__link, .ah__btn, .ah__link, [class*="__btn--main"]').forEach(function(el){
      el.classList.add('mo-mag');
      el.addEventListener('pointermove',function(e){
        var r=el.getBoundingClientRect();
        el.style.setProperty('--tx',((e.clientX-r.left-r.width/2)*.22).toFixed(1)+'px');
        el.style.setProperty('--ty',((e.clientY-r.top-r.height/2)*.3).toFixed(1)+'px');
      },{passive:true});
      el.addEventListener('pointerleave',function(){el.style.setProperty('--tx','0px');el.style.setProperty('--ty','0px')});
    });
  }

  function scroll(b){
    var h=document.querySelector(HERO),tick=false;
    function run(){
      tick=false;
      var y=window.pageYOffset||root.scrollTop,max=Math.max(1,root.scrollHeight-innerHeight);
      b.style.setProperty('--sp',Math.min(1,y/max).toFixed(4));
      if(h){var hh=Math.max(1,h.offsetHeight);h.style.setProperty('--hp',Math.min(1,Math.max(0,y/hh)).toFixed(3))}
    }
    addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(run)}},{passive:true});
    addEventListener('resize',run);run();
  }

  function init(){
    var b=bar();
    root.classList.add('mo-on');
    if(home)reveals();
    fixDrag();magnetic();scroll(b);
    load('sh','grim-shaders.js',function(){
      SH=window.__gsh||{};
      shaders();
      load('pk','grim-pick.js');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();